import styled from 'styled-components';

import { BorderRadius, BorderWidth, Color, FontSize, Spacing } from '@ninox/ninox-components/theme';

export const Container = styled.div`
    font-size: ${FontSize.small};
    line-height: 1.5;
    z-index: 10;
    position: absolute;
    top: 293px;
    left: 0;
    width: 100%;
    text-align: center;
`;

export const PointerWrapper = styled.div`
    font-size: 0;
    line-height: 0;
`;

export const PointerBorder = styled.div`
    top: ${BorderWidth.tiny};
    position: relative;
    display: inline-block;
    width: 0;
    height: 0;
    border-top: none;
    border-bottom: ${Spacing.medium} solid ${({ theme }) => theme.grid.secondary};
    border-left: ${Spacing.medium} solid transparent;
    border-right: ${Spacing.medium} solid transparent;
`;

export const Pointer = styled.div`
    position: absolute;
    left: calc(${BorderWidth.tiny} - ${Spacing.medium});
    top: ${BorderWidth.tiny};
    display: inline-block;
    width: 0;
    height: 0;
    border-top: none;
    border-bottom: calc(${Spacing.medium} - ${BorderWidth.tiny}) solid ${({ theme }) => theme.surface.secondary};
    border-left: calc(${Spacing.medium} - ${BorderWidth.tiny}) solid transparent;
    border-right: calc(${Spacing.medium} - ${BorderWidth.tiny}) solid transparent;
`;

export const HintContainer = styled.div`
    text-align: left;
    display: inline-block;
    background: ${({ theme }) => theme.surface.secondary};
    border: ${BorderWidth.tiny} solid ${({ theme }) => theme.grid.secondary};
    border-radius: ${BorderRadius.medium};
    padding: ${Spacing.medium};
`;

export const Hint = styled.div<{ valid?: boolean }>`
    color: ${({ valid }) => valid && Color.validation.success[700]};
`;
